import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  DomainObject,
  EmptyComponent,
  abortableFetch,
  useEventCallback,
} from '@eas/common-web';
import { useValidationSchema } from '../collection-schema';
import { CollectionToolbarAction } from '../collection-toolbar';

export function useUnassignCollectionDialog<T extends DomainObject>(
  getUrl: (id: string, collectionId: string) => string
) {
  const callApi = useEventCallback(
    (id: string, collectionId: string, formData: T) => {
      return abortableFetch(`${getUrl(id, collectionId)}`, {
        method: 'PUT',
        headers: new Headers({
          'Content-Type': 'application/json',
        }),
        body: JSON.stringify(formData),
      });
    }
  );

  return {
    callApi,
  };
}

export function resolveUnassignAction<T extends DomainObject>(
  props: CollectionToolbarAction<typeof useUnassignCollectionDialog<T>, T>
) {
  return {
    hide: false,
    useApi: useUnassignCollectionDialog,
    Dialog: EmptyComponent,
    label: (
      <FormattedMessage
        id="ZSD__COLLECTIONS__UNASSIGN_LABEL"
        defaultMessage="Odobrať"
      />
    ),
    title: (
      <FormattedMessage
        id="ZSD__COLLECTIONS__UNASSIGN_TITLE"
        defaultMessage="Odobrať"
      />
    ),
    text: (
      <FormattedMessage
        id="ZSD__COLLECTIONS__DELETE_TEXT"
        defaultMessage="Skutočne chcete odobrať položku?"
      />
    ),
    initValues: (values: T) => values,
    dialogWidth: 400,
    useSchema: useValidationSchema,
    ...props,
  };
}
